import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0, {
      behavior: 'smooth',
    });
  }, [location]);
  return (
    <div className="hidden" />
  );
}

export default ScrollToTop;
